import Element from '../Menu/menu-group'

Element.install = function (Vue) {
  Vue.component(Element.name, Element)
}

export default Element



// WEBPACK FOOTER //
// ./src/package/MenuGroup/index.js